export default "__VITE_ASSET__anoLB0l2__"